import PageLayout from "components/layout/PageLayout"
import { useTranslation } from "react-i18next"
import { useEffect, useState } from "react"
import { Dialog } from "primereact/dialog"
import NoData from "components/commons/NoData"
import {
    useLazyGetDevicesDiagnosticsResumeQuery,
    useClearAllDeviceLogsMutation
} from "./api/deviceDiagnosticsApiSlice"
import DiagnosticCard from "./view/DiagnosticCard"


function DeviceDiagnostics() {
    const [t] = useTranslation(["global", "device"])
    const [showClearAllDialog, setShowClearAllDialog] = useState(false)

    const [getDiagnostics, {
        data: resumes,
        isLoading,
        isFetching,
        isSuccess,
        isError,
        error
    }] = useLazyGetDevicesDiagnosticsResumeQuery()

    const [clearAllLogs, { isLoading: isClearing }] = useClearAllDeviceLogsMutation()

    useEffect(() => {
        getDiagnostics()
    }, [getDiagnostics])

    const handleClearAll = async () => {
        await clearAllLogs()
        setShowClearAllDialog(false)
    }

    const content = (
        <>
            <div className="d-flex justify-content-end mb-3">
                <button
                    className="btn btn-outline-danger"
                    onClick={() => setShowClearAllDialog(true)}
                    disabled={!resumes?.length}
                >
                    <i className="fa-solid fa-trash me-1" />
                    {t("device:diagnostics.clear_all_logs")}
                </button>
            </div>

            {isSuccess && (
                resumes?.length > 0
                    ? (
                        <div className="row g-3">
                            {resumes.map(resume => (
                                <div className="col-12 col-md-6 col-xl-4" key={resume.device.guid}>
                                    <DiagnosticCard resume={resume} />
                                </div>
                            ))}
                        </div>
                    )
                    : <NoData message={t("device:diagnostics.no_logs")} />
            )}

            <Dialog
                header={t("device:diagnostics.clear_all_logs_confirm_title")}
                visible={showClearAllDialog}
                onHide={() => setShowClearAllDialog(false)}
            >
                <p>{t("device:diagnostics.clear_all_logs_confirm_msg")}</p>
                <div className="text-end mt-3">
                    <button
                        className="btn btn-danger me-2"
                        onClick={handleClearAll}
                        disabled={isClearing}
                    >
                        {t("action.confirm")}
                    </button>
                    <button className="btn btn-secondary" onClick={() => setShowClearAllDialog(false)}>
                        {t("action.cancel")}
                    </button>
                </div>
            </Dialog>
        </>
    )

    return (
        <PageLayout
            pageTitle={t("device:menu.devices_diagnostics")}
            bodyContent={content}
            isLoadingPage={isLoading}
            isLoadingContent={isFetching || isClearing}
            isError={isError}
            errorMsg={error}
            onPageRefresh={getDiagnostics}
        />
    )
}

export default DeviceDiagnostics
